import { API_BASE_URL } from '@/config/api';

export async function syncOfflineActivity() {
    if (!navigator.onLine) return;

    const sesion = localStorage.getItem("token");
    if (!sesion) return;

    // Sync SetPlay
    const playsKey = `offline_plays_${sesion}`;
    let savedPlays = [];
    try {
        savedPlays = JSON.parse(localStorage.getItem(playsKey) || '[]');
    } catch (e) { console.error(e); }

    if (savedPlays.length > 0) {
        const remainingPlays = [];
        for (const payload of savedPlays) {
            try {
                const response = await fetch(`${API_BASE_URL}/api/config/SetPlay`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                });
                if (!response.ok) remainingPlays.push(payload);
            } catch (error) {
                remainingPlays.push(payload);
            }
        }
        if (remainingPlays.length === 0) {
            localStorage.removeItem(playsKey);
        } else {
            localStorage.setItem(playsKey, JSON.stringify(remainingPlays));
        }
    }

    // Sync SetMoment
    const momentsKey = `offline_moments_${sesion}`;
    let savedMoments = [];
    try {
        savedMoments = JSON.parse(localStorage.getItem(momentsKey) || '[]');
    } catch (e) { console.error(e); }

    if (savedMoments.length > 0) {
        const remainingMoments = [];
        for (const payload of savedMoments) {
            try {
                const response = await fetch(`${API_BASE_URL}/api/config/SetMoment`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                });
                if (!response.ok) remainingMoments.push(payload);
            } catch (error) {
                remainingMoments.push(payload);
            }
        }
        if (remainingMoments.length === 0) {
            localStorage.removeItem(momentsKey);
        } else {
            localStorage.setItem(momentsKey, JSON.stringify(remainingMoments));
        }
    }
}
